import type { DataContainer } from "@otto-ec/tracking-bct";
import { createLogger } from "utils/logging";

const log = createLogger("tag", "detailview.model");

export type Detailview = {
	benefitId: string;
	frameId?: string;
	activeUntil: string;
	variationId: string;
	activationStatus: ActivationStatus;
	tracking: Tracking;
	isAppOnly: boolean;
	isEarlyAccess?: boolean;
	value: string;
	unit: string;
	displayName: string;
};

export class Tracking {
	constructor(
		readonly id: string,
		readonly name: string,
		readonly labels: DataContainer,
	) {}
}

export enum ActivationStatus {
	DEACTIVATED = "DEACTIVATED",
	ACTIVATED = "ACTIVATED",
}

export function buildDetailview(detailviewBenefitElement: HTMLElement, actionContainer: HTMLElement, variationId: string): Detailview | null {
	const isAppOnly = actionContainer.dataset.isAppOnly === "true";
	const activationStatus = actionContainer.dataset.activationStatus as ActivationStatus;
	const isEarlyAccess = actionContainer.dataset.isEarlyAccess === "true";

	const benefitId = actionContainer.dataset.benefitId;
	if (!benefitId) {
		log.error("Missing benefitId");
		return null;
	}
	const frameId = actionContainer.dataset.frameId;
	const activeUntil = actionContainer.dataset.activeUntil;
	if (!activeUntil) {
		log.error("Missing activeUntil");
		return null;
	}
	const value = actionContainer.dataset.value;
	if (!value) {
		log.error("Missing value");
		return null;
	}
	const unit = actionContainer.dataset.unit;
	if (!unit) {
		log.error("Missing unit");
		return null;
	}
	const displayName = actionContainer.dataset.displayName;
	if (!displayName) {
		log.error("Missing displayName");
		return null;
	}

	const tracking = detailviewBenefitElement.dataset.tracking;

	if (!tracking) {
		log.error("Missing tracking");
		return null;
	}

	return {
		benefitId,
		frameId,
		activeUntil,
		activationStatus,
		tracking: JSON.parse(tracking) as Tracking,
		variationId,
		isAppOnly,
		isEarlyAccess,
		value,
		unit,
		displayName,
	};
}
